import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadarRingInner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 266,
	height: 196,
	viewBox: "0 0 266 196",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M133 0.432C206.209 0.432 265.568 60.774 265.568 135.225C265.568 209.676 206.209 270.018 133 270.018C59.791 270.018 0.432 209.676 0.432 135.225C0.432 60.774 59.791 0.432 133 0.432Z",
		stroke: "url(#radar-ring-inner)",
		strokeWidth: .863
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "radar-ring-inner",
		x1: 133,
		y1: 0,
		x2: 133,
		y2: 196,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .072,
				stopColor: "#0D081C"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .192,
				stopColor: "#DFCBF5",
				stopOpacity: .5
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .322,
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopColor: "#0D081C"
			})
		]
	}) })]
});
export default SvgRadarRingInner;
